export default __webpack_public_path__ + "5982461fe2304c26f3a3cf4c50806dad.svg";